export class ApiError extends Error {
  status: number
  responseBody?: string
  // ErrorCodeDto from the API body, when present
  errorCode: number | null = null
  // Message from the API body, when present
  apiMessage: string | null = null

  constructor(status: number, statusText: string, responseBody?: string) {
    let readableMessage = statusText || "Unknown error"
    let errorCode: number | null = null
    let apiMessage: string | null = null
    try {
      const parsed = JSON.parse(responseBody || "")
      if (parsed.message) {
        readableMessage = parsed.message
        apiMessage = parsed.message
      }
      if (typeof parsed.errorCode === "number") errorCode = parsed.errorCode
    } catch {}

    super(`${readableMessage} (${status})`)
    this.name = "ApiError"
    this.status = status
    this.responseBody = responseBody
    this.errorCode = errorCode
    this.apiMessage = apiMessage
  }
}
